var __jsx = React.createElement;
import React, { useState, useEffect, useRef } from "react";
import { Icon } from "@syarahtech/ui";
import { AccordionItemProvider, useAccordionItem } from "./AccordionItemContext";
import useBoolean from "@hooks/useBoolean";
import { twMerge } from "tailwind-merge";
var AccordionItem = function AccordionItem(_ref) {
  var children = _ref.children,
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? "bg-white" : _ref$background,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? "border-gray-azureish" : _ref$borderColor,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var _useBoolean = useBoolean(defaultOpen),
    open = _useBoolean.value,
    toggleOpen = _useBoolean.toggle;
  return /*#__PURE__*/React.createElement(AccordionItemProvider, {
    open: open,
    toggleOpen: toggleOpen
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge('border rounded border-solid', background, borderColor, className)
  }, children));
};
var Accordion = function Accordion(_ref2) {
  var children = _ref2.children,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("space-y-2", className)
  }, children);
};
var AccordionTitle = function AccordionTitle(_ref3) {
  var children = _ref3.children,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    _ref3$iconContainerCl = _ref3.iconContainerClassName,
    iconContainerClassName = _ref3$iconContainerCl === void 0 ? '' : _ref3$iconContainerCl,
    _ref3$onClick = _ref3.onClick,
    onClick = _ref3$onClick === void 0 ? function () {} : _ref3$onClick;
  var _useAccordionItem = useAccordionItem(),
    open = _useAccordionItem.open,
    toggleOpen = _useAccordionItem.toggleOpen;
  var handleTitleClick = function handleTitleClick() {
    toggleOpen();
    onClick();
  };
  return /*#__PURE__*/React.createElement("button", {
    className: twMerge("w-full px-4 py-2 text-gray-700 focus:outline-none relative text-start bg-transparent border-0", className),
    onClick: handleTitleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("absolute top-[50%] ar:left-3 en:right-3 transform translate-y-[-50%] h-6", iconContainerClassName)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: open ? "material-symbols--keyboard-arrow-up-rounded" : "material-symbols--keyboard-arrow-down-rounded",
    width: 6,
    height: 6,
    className: "text-gray-text"
  })), children);
};
var AccordionBody = function AccordionBody(_ref4) {
  var _ref4$className = _ref4.className,
    className = _ref4$className === void 0 ? '' : _ref4$className,
    children = _ref4.children;
  var contentRef = useRef(null);
  var _useAccordionItem2 = useAccordionItem(),
    open = _useAccordionItem2.open;
  var _useState = useState("0px"),
    maxHeight = _useState[0],
    setMaxHeight = _useState[1];
  useEffect(function () {
    if (contentRef.current) {
      setMaxHeight(open ? "".concat(contentRef.current.scrollHeight, "px") : "0px");
    }
  }, [open]);
  useEffect(function () {
    if (contentRef.current) {
      setMaxHeight(open ? "".concat(contentRef.current.scrollHeight, "px") : "0px");
    }
  }, [open]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: contentRef,
    className: "overflow-hidden transition-all duration-500 ease-in-out",
    style: {
      maxHeight: maxHeight,
      transitionProperty: "max-height, opacity",
      opacity: open ? 1 : 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge('p-4', className)
  }, children)));
};
//@ts-ignore
Accordion.Item = AccordionItem;
Accordion.Title = AccordionTitle;
Accordion.Body = AccordionBody;
export default Accordion;